import React, { useEffect, useState } from "react";
import axios from "axios";

const StatistiquesAdmin = () => {
  const [stats, setStats] = useState(null);
  const [topCategories, setTopCategories] = useState([]);
  const [publicationStats, setPublicationStats] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [annoncesRes, usersRes, topCatRes, publicationRes] =
          await Promise.all([
            axios.get(
              `${process.env.REACT_APP_API_URL}/api/admin/stats/annonces`,
              { withCredentials: true }
            ),
            axios.get(
              `${process.env.REACT_APP_API_URL}/api/admin/stats/utilisateurs`,
              { withCredentials: true }
            ),
            axios.get(
              `${process.env.REACT_APP_API_URL}/api/admin/stats/top-categories`,
              { withCredentials: true }
            ),
            axios.get(
              `${process.env.REACT_APP_API_URL}/api/admin/stats/publication`,
              { withCredentials: true }
            ),
          ]);

        setStats({
          ...annoncesRes.data,
          totalUsers: usersRes.data.total,
        });
        setTopCategories(topCatRes.data);
        setPublicationStats(publicationRes.data);
      } catch (error) {
        console.error("Erreur de récupération des stats :", error);
      }
    };

    fetchStats();
  }, []);

  if (!stats) return <p>Chargement des statistiques...</p>;

  return (
    <div className="admin-stats" style={{ padding: "1rem" }}>
      <div className="stackStats">
        <ul>
          <li>
            <strong>Annonces totales :</strong> {stats.total}
          </li>
          <li>
            <strong>Annonces aujourd’hui :</strong> {stats.today}
          </li>
          <li>
            <strong>Cette semaine :</strong> {stats.week}
          </li>
          <li>
            <strong>Ce mois-ci :</strong> {stats.month}
          </li>
          <li>
            <strong>Cette année :</strong> {stats.year}
          </li>
          <li>
            <strong>Utilisateurs enregistrés :</strong> {stats.totalUsers}
          </li>
        </ul>
      </div>
      <div className="stackStats">
        <h3>Top 5 des catégories</h3>
        <ul>
          {topCategories.map((cat) => (
            <li key={cat._id}>
              {cat._id} : {cat.total} annonces
            </li>
          ))}
        </ul>
      </div>
      <div className="stackStats">
        <h3>Statut de publication</h3>
        <p>
          {publicationStats?.nonPublie} annonces non publiées (
          {publicationStats?.pourcentage}%)
        </p>
      </div>
    </div>
  );
};

export default StatistiquesAdmin;
